import NumberType from "../../../../types/report/NumberType";

const updateNumbers = (fields: NumberType[]) => {

    for (var i = 0; i < fields.length; i++) {
        fields[i].number = i + 1;
    }
}

export { updateNumbers }
